// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2rTmr","info":"Note_info__31_QW","note":"Note_note__1wx8N","actions":"Note_actions__1Wy6j"};